$(document).ready(function () {
  const $body = $('body');

  const rutubeIframes = $('iframe[src*="rutube.ru"]');
  rutubeIframes.each((_, el) => {
    el.$player = {
      playVideo() {
        el.contentWindow.postMessage(
          JSON.stringify({
            type: 'player:setCurrentTime',
            data: {
              time: 0,
            },
          }),
          '*',
        );
        el.contentWindow.postMessage(
          JSON.stringify({
            type: 'player:play',
            data: {},
          }),
          '*',
        );
      },
      pauseVideo() {
        el.contentWindow.postMessage(
          JSON.stringify({
            type: 'player:pause',
            data: {},
          }),
          '*',
        );
      },
    };
  });

  window.addEventListener('message', (e) => {
    if (e.origin === 'https://rutube.ru') {
      const iframe = rutubeIframes.filter(function () {
        return this.contentWindow === e.source;
      });
      if (iframe.length) {
        try {
          const rutubeAPIData = JSON.parse(e.data);
          const [_, eventType] = rutubeAPIData.type.split(':');
          iframe[0].dispatchEvent(
            new CustomEvent(eventType, {
              detail: rutubeAPIData.data,
            }),
          );
        } catch (e) {
          //
        }
      }
    }
  });

  $('[data-button-play]').on('click', function (e) {
    e.preventDefault();
    $(this).addClass('_hide');
    $('[data-top-video]').addClass('_show');
    const player = $('[data-top-video]').get(0);
    if (player?.src.includes('rutube')) {
      player.$player?.playVideo();
    } else {
      $('[data-top-video]')[0].src += '?rel=0&autoplay=1';
    }
  });

  /*$('[data-callme-button]').on('click', function(e) {
    e.preventDefault();
    $('[data-callme]').toggleClass('_success');
  });*/
  $('[data-contacts-button]').on('click', function (e) {
    e.preventDefault();
    $('[data-contacts]').removeClass('_success');
  });

  $('[data-acc-item]').on('click', function () {
    const $accContent = $('[data-acc-content]');
    if (!$(this).hasClass('_active')) {
      $('[data-acc-item]').removeClass('_active');
      $accContent.slideUp(200);
      $(this).addClass('_active');
      $(this).find($accContent).slideDown(200);
    }
  });

  $('[data-coach-button]').on('click', coachPopupShow);
  $('[data-popup-coach-close]').on('click', coachPopupHide);

  function coachPopupShow() {
    const coachData = $(this).closest('[data-coach]').data('coach');
    coachPopupData(coachData);
    coachPopupPosition.call(this);
    const offset = window.innerWidth - $body.width();
    $body.css('--overflow-offset', `${offset}px`);
    $body.addClass('_overflowHidden');
  }

  function coachPopupData(data) {
    const $coachPopup = $('[data-popup-coach]');
    const $coachInfoEl = $coachPopup.find('[data-coach-info]');
    const $coachPhotoEl = $coachPopup.find('[data-coach-photo]').find('img');
    const $coachFactsEl = $coachPopup.find('[data-coach-facts] ul');
    const $coachPricesEl = $coachPopup.find('[data-coach-prices]');
    const $coachNameEl = $coachPopup.find('[data-coach-name]');
    const priceTemplate = (data) => {
      return `<div class="coach-popup__price">
          <div class="coach-popup__priceLabel">${data.type}</div>
          <div class="coach-popup__priceValue">${data.price} ₽</div>
        </div>`;
    };
    $coachPhotoEl.attr('src', data.img);
    $coachNameEl.html(data.name);
    $coachInfoEl.html(`${data.info || ''}`);
    $coachFactsEl.html('');
    $coachPricesEl.html('');
    for (let fact of data.facts || []) {
      $coachFactsEl.append(`<li>${fact}</li>`);
    }
    for (let price of data.prices || []) {
      $coachPricesEl.append(priceTemplate(price));
    }
  }

  function coachPopupPosition() {
    const popupPosition = $(this).position().left <= window.innerWidth / 2 ? 'right' : 'left';
    const coach = $(this).closest('[data-coach]');
    coach.addClass('_active');
    $('[data-popup-coach]').addClass(`_${popupPosition}`);
    setTimeout(() => {
      $('[data-popup-coach], [data-popup-overlay]').addClass('_show');
    }, 30);
  }

  function coachPopupHide() {
    $('[data-popup-coach], [data-popup-overlay]').removeClass('_show');
    $('[data-popup-coach]').one('transitionend', function () {
      $(this).removeClass('_left _right');
    });
    $('[data-coach]').removeClass('_active');
    $body.removeClass('_overflowHidden');
  }

  /*start schedule*/
  const $scheduleRows = $('[data-schedule-row]');
  const $legends = $('[data-schedule-legend]');
  const $items = $('[data-schedule-name]');

  const $popupDay = $('[data-popup-day]');
  const $popupStart = $('[data-popup-start]');
  const $popupDuration = $('[data-popup-duration]');
  const $popupText = $('[data-popup-text]');
  const $popupTrainer = $('[data-popup-trainer]');
  const $popupName = $('[data-popup-name]');
  const $popupsNodes = [
    $popupDay,
    $popupStart,
    $popupDuration,
    $popupText,
    $popupTrainer,
    $popupName,
  ];

  let isHidePopup = true;

  const clearPopup = () => {
    $popupsNodes.forEach(($e) => {
      $e.text('');
    });

    $('[data-popup-img]').remove();
  };

  const addContentPopup = (data) => {
    $popupDay.text(data.day);
    $popupStart.text(data.start);
    $popupDuration.text(data.duration);
    $popupText.html(data.text);
    $popupTrainer.text(data.trainer);
    $popupName.text(data.name);

    if (data.img) {
      $popupText.after(
        `<img src="${data.img}" alt="" data-popup-img class="schedule-popup__img" />`,
      );
    }
  };

  const hidePopup = () => {
    $body.removeClass('_overflowHidden');
    $('[data-popup], [data-popup-overlay]').removeClass('_show');
    $('[data-info]').removeClass('_active');
    coachPopupHide();

    isHidePopup = true;
  };

  const showPopup = () => {
    $body.addClass('_overflowHidden');
    $('[data-popup], [data-popup-overlay]').addClass('_show');

    isHidePopup = false;
  };

  const checkAndSlideUp = (type) => {
    $scheduleRows.each(function () {
      const isAll = type === 'all';
      const haveElements = isAll
        ? $(this).find('[data-schedule-name]').length
        : $(this).find(`[data-schedule-name="${type}"]`).length;
      const $items = $(this).find('[data-schedule-items]');
      const $name = $(this).find('.schedule__name');

      if (haveElements) {
        $items.slideDown(0);
        $name.addClass('_open');
      } else {
        $items.slideUp(0);
        $name.removeClass('_open');
      }
    });
  };

  checkAndSlideUp('all');

  $('[data-info]').on('click', function (e) {
    e.preventDefault();

    const $target = $(this);
    $target.addClass('_active');
    if (!isHidePopup) {
      hidePopup();
      setTimeout(() => {
        showPopup();
      }, 350);
    } else {
      showPopup();
    }

    const data = $target.data('info');
    clearPopup();
    addContentPopup(data);
  });

  $('[data-popup-close], [data-popup-overlay]').on('click', function (e) {
    e.preventDefault();
    hidePopup();
  });

  $legends.on('click', (evt) => {
    const name = $(evt.currentTarget).data('schedule-legend');
    console.log(name);
    if ($(`[data-schedule-legend="${name}"]`).hasClass('_active')) {
      $legends.removeClass('_active');
      $items.parent().fadeIn();
      checkAndSlideUp('all');
    } else {
      $legends.removeClass('_active');
      $items.parent().hide();

      $(`[data-schedule-legend="${name}"]`).addClass('_active');
      if (name === 'all') $items.parent().fadeIn();
      else $(`[data-schedule-name="${name}"]`).parent().fadeIn(600);

      checkAndSlideUp(name);
    }
  });

  $scheduleRows.on('click', '.schedule__name', function () {
    const xs = window.matchMedia('(max-width: 767px)').matches;
    if (xs) {
      $(this).next().slideToggle(500);
      $(this).toggleClass('_open');
    }
  });
  /*end schedule*/
  /* Yandex Map */
  const mapEl = $('[data-contacts-map]');
  const placeCoords = [55.796359, 37.491862];
  window.ymaps.ready(() => {
    const zoomControl = new ymaps.control.ZoomControl({
      options: {
        size: 'small',
        float: 'none',
      },
    });
    const geolocationControl = new ymaps.control.GeolocationControl({
      options: {
        float: 'none',
      },
    });
    const placemark = new ymaps.Placemark(
      placeCoords,
      {},
      {
        iconLayout: 'default#image',
        iconImageHref: 'img/map_pin.svg',
        iconImageSize: [70, 102],
        iconImageOffset: [-35, -102],
      },
    );
    const map = new ymaps.Map(mapEl[0], {
      zoom: 14,
      center: placeCoords,
      controls: [geolocationControl, zoomControl],
    });
    map.geoObjects.add(placemark);
  });
  /* End Yandex Map */

  function initSwiperSlider() {
    new Swiper('[data-reviews-video]', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '._reviews-video._next',
        prevEl: '._reviews-video._prev',
      },
      on: {
        slideChange() {
          pauseAllVideos(this.slides);
          this.slides.forEach((el) => {
            // Init new player after loop
            initPlayer(el);
          });
        },
        async click() {
          const slideEl = this.clickedSlide;
          pauseAllVideos(this.slides);
          slideEl.$player.playVideo();
        },
      },
      breakpoints: {
        1440: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      },
    });
  }

  initYTScript().then(initSwiperSlider);

  async function initYTScript() {
    const ytIframes = $('.reviews-video iframe[src*="youtu"]');
    if (!ytIframes.length) return Promise.resolve();

    if (window.YT?.loaded) return Promise.resolve();

    return new Promise((resolve, reject) => {
      if (window.YT) window.YT.ready(resolve);
      else {
        const script = $(document.head).find('[src="https://www.youtube.com/iframe_api"]');
        script.one('load', () => {
          window.YT.ready(resolve);
        });
        script.one('error', () => {
          reject(new Error("Can't load YT script"));
        });
      }
    });
  }

  async function initPlayer(slideEl) {
    const iframe = slideEl.querySelector('iframe');
    const iframeSrc = new URL(iframe.src);
    const onStateChange = (isPlaying) => {
      $(slideEl).find('.reviews-video-slide').toggleClass('_playing', isPlaying);
    };

    return new Promise((resolve, reject) => {
      if (iframeSrc.host.includes('rutube') && !slideEl.$player) {
        iframe.addEventListener('ready', (e) => {
          slideEl.$player = iframe.$player;
          resolve(iframe);
        });
        iframe.addEventListener('changeState', (e) => {
          onStateChange(e.detail.state === 'playing');
        });
      } else if (iframeSrc.host.includes('youtu')) {
        new YT.Player(iframe, {
          events: {
            onReady(event) {
              slideEl.$player = event.target;
              resolve(event.target);
            },
            onStateChange(event) {
              onStateChange(event.data === YT.PlayerState.PLAYING);
            },
          },
        });
      }
    });
  }

  function pauseAllVideos(slides, current) {
    slides.forEach((el) => {
      if (current && el === current) return;
      el.$player?.pauseVideo();
    });
  }

  // Reviews blocks
  const clientsNames = $('.client-history-name');
  const clientsCommentBlock = $('.client-history-text');
  const clientsCommentText = $('.client-history-text__wrapper');
  const clientsMore = $('.client-history-text__button');
  let transitionMs = 0;

  setTimeout(() => {
    clientsCommentBlock.toggleClass('_more', isTextOverflowing(clientsCommentText, -2));
  }, 50);

  const media = window.matchMedia('(max-width: 1279px)');
  media.addEventListener('change', ({ matches }) => {
    detachCommentBlock(matches);
  });
  detachCommentBlock(media.matches);

  /**
   * @param {boolean} matches
   */
  function detachCommentBlock(matches) {
    const el = $(clientsCommentBlock).detach();
    if (matches) {
      el.insertAfter(clientsNames.filter('._active'));
    } else {
      $('.clients-history__col._col1').append(el);
    }
  }

  clientsNames.on('click', (e) => {
    $(e.currentTarget).addClass('_active').siblings().removeClass('_active');
    clientsCommentBlock.removeClass('_open');
    const currentClientComment = clientsNames.filter('._active').data().clientComment;
    const targetEl = media.matches ? '.client-history-name' : '.clients-history';
    const offset = media.matches ? -($('.header').height() ?? 0) : 0;
    scrollTo($(targetEl), offset);
    detachCommentBlock(media.matches);
    toggleCommentText(currentClientComment);
  });
  clientsMore.on('click', () => {
    const isBlockOpen = clientsCommentBlock.hasClass('_open');
    const targetEl = !media.matches ? '.clients-history' : '.client-history-name';
    const offset = media.matches ? -($('.header').height() ?? 0) : 0;
    isBlockOpen && scrollTo($(targetEl), offset);
    clientsCommentBlock.toggleClass('_open');
  });

  /**
   * @param {JQuery<HTMLElement>} el
   * @param {number} [offset]
   */
  function scrollTo(el, offset = 0) {
    if (!(el && el.length)) return;
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: el.offset().top + offset,
      },
      100,
    );
  }

  /**
   * @param {JQuery} block
   * @param {number} [offset]
   */
  function isTextOverflowing(block, offset = 0) {
    const textHeight = block.height() || 0;
    const blockHeight = (block.parent() || $()).height() || 0;
    return textHeight + offset > blockHeight;
  }

  /**
   * @param {string} text
   */
  function toggleCommentText(text) {
    clientsCommentText.animate(
      {
        opacity: 0,
      },
      transitionMs,
      () => {
        clientsCommentText.html(text);
        clientsCommentBlock.toggleClass('_more', isTextOverflowing(clientsCommentText, -2));
        clientsCommentText.animate(
          {
            opacity: 1,
          },
          transitionMs,
        );
      },
    );
  }
});
